export default (num) => {
	return num > 999 ? (num/1000).toFixed() + 'k' : num
}